import {
  createLeadMutation,
  getLeadQuery,
  updateLeadMutation,
} from "@brexhq/next/src/api/marketo";
import { checkInternalLink } from "@brexhq/next/src/utils/links";
import { CreateLeadInput, UpdateLeadInput } from "@brexhq/next/types/brex-api";
import { createMockableHook } from "@brexhq/shared/utils/createMockableHook";

const _useCreateLead = () => {
  return async (createLeadInput: CreateLeadInput) => {
    const response = await createLeadMutation(createLeadInput);

    if (response.errors) {
      const message = response.errors.map((e: any) => e.message).join("/n");
      throw new Error(message);
    }

    return response.data.createLead.lead;
  };
};

export const [useCreateLead, MockUseCreateLead] =
  createMockableHook(_useCreateLead);

const _useUpdateLead = () => async (updateLeadInput: UpdateLeadInput) => {
  const response = await updateLeadMutation(updateLeadInput);

  if (response.errors) {
    const message = response.errors.map((e: any) => e.message).join("/n");
    throw new Error(message);
  }

  return response;
};

export const [useUpdateLead, MockUseUpdateLead] =
  createMockableHook(_useUpdateLead);

export const _useGetLead = () => async (leadToken: string) => {
  const response = await getLeadQuery(leadToken);
  if (response.errors) {
    const message = response.errors.map((e: any) => e.message).join("/n");
    throw new Error(message);
  }

  return response.data.lead;
};

export const [useGetLead, MockUseGetLead] = createMockableHook(_useGetLead);

export const _useBypassSuccess =
  () =>
  (bypassSuccessContentUrl?: {
    to: string | null;
    toExternal: string | null;
    noFollow?: boolean | null;
  }) => {
    const shouldBypass =
      !!bypassSuccessContentUrl?.to || !!bypassSuccessContentUrl?.toExternal;

    let url = "";

    const { link, isInternalLink } = checkInternalLink(
      bypassSuccessContentUrl?.to || bypassSuccessContentUrl?.toExternal || "",
    );

    if (!isInternalLink) {
      /**
       * makes sure we add the https:// if it doesn't have it in our external url
       */
      if (!link.startsWith("http")) {
        url = "https://" + link;
      }
    } else {
      url = link;
    }

    return {
      shouldBypass,
      link: url,
      isInternalLink,
    };
  };

export const [useBypassSuccess, MockUseBypassSuccess] =
  createMockableHook(_useBypassSuccess);
